import { ThemeProvider } from "@climatepartner/components/Theme";
import { RouteObject } from "react-router-dom";

import { NETWORK_SUPPLIER_FORWARD_INVITE_PATH } from "../../../shared/routing/paths/network";
import { themePalette } from "../../../shared/ui/theme-palette";
import { SupplierForwardPage } from "./registration/components/supplier-forward-page";

/**
 * Public, like SupplierPublicRoutes: mounted outside AppLayout/AppShell, with its own ThemeProvider.
 * The forward link is token-authenticated (cr + token query params), so no session is required.
 */
export const SupplierForwardRoutes: RouteObject = {
  path: NETWORK_SUPPLIER_FORWARD_INVITE_PATH,
  element: (
    <ThemeProvider theme={themePalette}>
      <SupplierForwardPage />
    </ThemeProvider>
  ),
};
